import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'

// Validate environment variables (fail-fast)
import '@/utils/env'

// Initialize Sentry for error tracking (before rendering)
import { initSentry } from '@/lib/sentry'
initSentry()

// Importar função de debug para testar endpoints
import { testEvolutionEndpoints } from './debug/test-evolution-endpoints'
import { EvolutionV2Service } from './services/evolution-v2.service'

// Disponibilizar no console para debug (tipos em src/types/global.d.ts)
if (typeof window !== 'undefined') {
  window.testEvolutionEndpoints = testEvolutionEndpoints
  window.fixRejectCall = () => new EvolutionV2Service().disableRejectCallAllInstances()
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)